import React from "react";
import PropTypes from "prop-types";
import ShowVideo from "./ShowVideo";
import GTMTracker from "../../utils/tracking/GTMTracker";
import Navigation from "../../utils/Navigation";
import { generateSmallThumbnailUrl } from "../../utils/ImageUtils";

function ShowModule(props) {
    const { title, subtitle, pageId, labelUrl, image, items } = props;
    const imageUrl = image && image.url;
    const linkUrl = labelUrl || `/series/${pageId}`;

    return (
        <div className="show-module">
            <h2 className="show-module__title">
                <a
                    className="show-module__title-link"
                    href={linkUrl}
                    target="_blank"
                    onClick={trackClick(pageId, "headline")}
                >
                    {title}
                </a>
            </h2>
            <div className="show-module__content">
                <div className="show-module__show">
                    <a
                        className="show-module__show-info"
                        href={linkUrl}
                        target="_blank"
                        onClick={trackClick(pageId, "image")}
                    >
                        {imageUrl && (
                            <img
                                className="show-module__show-img"
                                loading="lazy"
                                src={generateSmallThumbnailUrl(
                                    imageUrl,
                                    266,
                                    149
                                )}
                                alt=""
                            />
                        )}
                        <span className="show-module__show-description">
                            {subtitle}
                        </span>
                    </a>
                    <div className="show-module__more-episodes">
                        <a
                            className="show-module__more-episodes-link"
                            href={linkUrl}
                            target="_blank"
                            onClick={trackClick(pageId, "link")}
                        >
                            More episodes and clips
                        </a>
                    </div>
                </div>
                <ul className="show-module__videos">
                    {items.map((videoStory) => (
                        <li key={videoStory.id} className="show-module__video">
                            <ShowVideo
                                {...videoStory}
                                onClick={trackVideo(pageId, videoStory)}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

function trackClick(pageId, label) {
    return () => {
        GTMTracker.trackEngagement({
            bvpEventAction: "click",
            bvpEventLabel: `video-btf_shows_${pageId}.${label}`,
        });
    };
}

function trackVideo(
    pageId,
    { headline: { html: headline }, video: { duration } }
) {
    return (event) => {
        GTMTracker.trackEngagement({
            bvpEventAction: "click",
            bvpEventLabel: `video-btf_shows_${pageId}.video`,
            mediaTitle: headline,
            mediaProgram: pageId,
            mediaDuration: duration,
        });

        Navigation.delayNavigateTo(event);
    };
}

ShowModule.defaultProps = {
    subtitle: "",
};

ShowModule.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    pageId: PropTypes.string.isRequired,
    labelUrl: PropTypes.string,
    image: PropTypes.shape({
        url: PropTypes.string,
    }),
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ShowModule;
